import type { LineItemMetrics } from '../../../../../../../apis/graphql';
import { formatDate } from '../../../../../../../utils/formatting';

export type Column = {
  id: string;
  Header: string;
  accessor: (li: LineItemMetrics) => string | number;
};

export const getReportPreviewColumns = (windowsCount: number): Column[] => {
  const schedulePacingColumns: Column[] = Array.from({ length: windowsCount }).map((_, idx) => ({
    id: `Schedule${idx + 1}Pacing`,
    Header: `Schedule ${idx + 1} Pacing (%)`,
    accessor: (li) => li.windows[idx]?.pacing ?? 0,
  }));

  const scheduleImpressionsColumns: Column[] = Array.from({ length: windowsCount }).map((_, idx) => ({
    id: `Schedule${idx + 1}Impressions`,
    Header: `Schedule ${idx + 1} Impressions`,
    accessor: (li) => li.windows[idx]?.totalImpressions ?? 0,
  }));

  return [
    {
      id: 'BrandName',
      Header: 'Brand/Advertiser Name',
      accessor: (li) => li.advertiserName ?? '',
    },
    {
      id: 'LineItemName',
      Header: 'Line Item Name',
      accessor: (li) => li.name,
    },
    {
      id: 'OMSPackageName',
      Header: 'OMS Package Name',
      accessor: (li) => li.OMSPackageName ?? '',
    },
    {
      id: 'OpportunityOrderType',
      Header: 'Opportunity Order Type',
      accessor: (li) => li.opportunityOrderType ?? '',
    },
    {
      id: 'Tier',
      Header: 'Tier',
      accessor: (li) => li.tier,
    },
    {
      id: 'LineItemPriority',
      Header: 'Line Item Priority',
      accessor: (li) => li.priority,
    },
    {
      id: 'LineItemStartDate',
      Header: 'Line Item Start Date',
      accessor: (li) => formatDate(new Date(li.startDate)),
    },
    {
      id: 'LineItemEndDate',
      Header: 'Line Item End Date',
      accessor: (li) => formatDate(new Date(li.endDate)),
    },
    {
      id: 'Delivered1P',
      Header: 'Delivered (1P)',
      accessor: (li) => li.delivered,
    },
    {
      id: 'LIDeliveryGoal',
      Header: 'LI Delivery Goal',
      accessor: (li) => li.deliveryGoal,
    },
    {
      id: 'LineItemID',
      Header: 'Line Item ID',
      accessor: (li) => li.id,
    },
    {
      id: 'PreSchedulePacingToDate',
      Header: 'Pre-Schedule Pacing To Date (%)',
      accessor: (li) => li.preSchedule.pacing,
    },
    ...schedulePacingColumns,
    {
      id: 'PostSchedulePacing',
      Header: 'Post-Schedule Pacing (%)',
      accessor: (li) => li.postSchedule.pacing,
    },
    {
      id: 'PreScheduleImpressions',
      Header: 'Pre-Schedule Impressions',
      accessor: (li) => li.preSchedule.totalImpressions,
    },
    ...scheduleImpressionsColumns,
    {
      id: 'PostScheduleImpressions',
      Header: 'Post-Schedule Impressions',
      accessor: (li) => li.postSchedule.totalImpressions,
    },
    {
      id: 'MoveForwardDeliveryGoal',
      Header: 'Move-Forward Delivery Goal',
      accessor: (li) => li.moveForwardDeliveryGoal,
    },
    {
      id: 'TrueEstimatedWindowShift',
      Header: 'True Estimated Window Shift',
      accessor: (li) => li.trueEstimatedWindowsShift,
    },
    {
      id: 'DifferenceOverStraightlineDaily',
      Header: 'Difference Over Straightline Daily',
      accessor: (li) => li.differenceOverStraightlineDaily,
    },
  ];
};
